import React from 'react';
import './CalibrationView.css';

export const CalibrationView = () => {
  return (
    <div className="calibration-view u-fade-in">
      <div className="calibration-content">
      {/* Main Border */}
      <div className="calibration-border"></div>
      
      {/* Center Crosshair */}
      <div className="calibration-center">
        <div className="crosshair-h"></div>
        <div className="crosshair-v"></div>
        <div className="center-circle"></div>
        <div className="center-dot"></div>
      </div>
      
      {/* Corner Markings */}
      <div className="corner corner-tl"></div>
      <div className="corner corner-tr"></div>
      <div className="corner corner-bl"></div>
      <div className="corner corner-br"></div>

      {/* Axis Labels */}
      <div className="axis-label axis-label--top">TOP</div>
      <div className="axis-label axis-label--bottom">BOTTOM</div>
      <div className="axis-label axis-label--left">LEFT</div>
      <div className="axis-label axis-label--right">RIGHT</div>



      {/* Background Grid */}
      <div className="calibration-grid"></div>
      </div>
    </div>
  );
};
